import { render, staticRenderFns } from "./AddImage.vue?vue&type=template&id=410a3f4c&scoped=true"
import script from "./AddImage.vue?vue&type=script&lang=js"
export * from "./AddImage.vue?vue&type=script&lang=js"
import style0 from "./AddImage.vue?vue&type=style&index=0&id=410a3f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410a3f4c",
  null
  
)

export default component.exports